import { Stack, alpha, Skeleton } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import Toolbar from "../Toolbar";

const ViewerWrapperLoader = () => {
  return (
    <>
      <Toolbar loading={true} />
      <Stack
        sx={{
          flex: 1,
          borderRadius: 2,
          borderColor: "divider",
          position: "relative",
          height: "100%",
        }}
      >
        <Skeleton height="100%" width="100%" />
      </Stack>
    </>
  );
};

export default ViewerWrapperLoader;
